<template>
  <div class="db relative w-100 aspect-ratio--16x9">
    <iframe class="dib w-100 aspect-ratio--object" :src="'https://player.vimeo.com/video/' + vimeoVideoId + '?autoplay=1&loop=1&autopause=0&muted=1&background=1'" width="100%" height="640" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
  </div>
</template>
<script>
export default {
  props: ['vimeoVideoId'],
  data() {
    return {
      //vimeoVideoId: ''
    }
  }
}
</script>

<style>

</style>
